import { Button } from '@catalyst/button';
import { Alert } from '@catalyst/alert';
import type { FallbackProps } from 'react-error-boundary';

export function ApiErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  const isNetworkError =
    error?.message?.toLowerCase().includes('network') ||
    error?.message?.toLowerCase().includes('fetch');
  const isAuthError = error?.status === 401 || error?.status === 403;

  return (
    <div className="p-6">
      <Alert color="red" open={true} onClose={() => {}}>
        <div className="space-y-3">
          <div className="font-medium">
            {isNetworkError
              ? 'Connection Error'
              : isAuthError
                ? 'Authentication Error'
                : 'API Error'}
          </div>
          <div className="text-sm">
            {isNetworkError
              ? 'Unable to connect to the server. Please check your internet connection and try again.'
              : isAuthError
                ? 'Your session has expired. Please sign in again.'
                : 'An error occurred while communicating with the server. Please try again.'}
          </div>
          <div className="flex gap-2">
            {isAuthError ? (
              <Button onClick={() => (window.location.href = '/auth/callback')}>
                Sign in again
              </Button>
            ) : (
              <Button onClick={resetErrorBoundary}>Retry</Button>
            )}
          </div>
        </div>
      </Alert>
    </div>
  );
}
